import React from 'react';

import './theme/_main.scss';

import TextLineEdit from '@plone/volto/components/manage/TextLineEdit/TextLineEdit';
import { NarrowContainer, Container } from '../../customizations/components/theme/Container/Container';
import Map from './Map.jsx'
import MapWithPopup from './MapWithPopup'

const View = (props) => {
    const { data, isEditMode, filteredToolbarProps } = props;

    const scribble1 = (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.6179 5C19.4278 6.4056 16.2252 7.76863 13.4021 9.84558C10.6182 11.8936 7.39471 14.3122 5.95733 17.574C4.42387 21.0538 4.67122 25.7313 7.14573 28.7372C8.8381 30.7931 11.3917 32.0582 13.8314 32.9848C17.8329 34.5045 22.1888 35.3619 26.4744 35.3846C28.5303 35.3955 30.6575 35.0679 32.2554 33.6748C33.8592 32.2766 34.8807 30.3878 35.3912 28.3385C36.4932 23.9152 36.3367 19.1025 33.5588 15.3505C32.4246 13.8187 31.0941 12.4127 29.2729 11.7317C26.4867 10.6899 23.1503 10.9026 20.2871 11.4403C16.9539 12.0663 13.743 13.2507 11.2706 15.6572C8.80081 18.0612 7.98933 21.2429 8.02744 24.597C8.06013 27.4735 8.82521 30.0624 10.8719 32.1644C12.2284 33.5576 13.915 34.5807 15.7942 35.1162C17.4027 35.5746 19.3327 35.7523 20.9924 35.6683C25.3386 35.4483 22.4204 35.2268 26.7581 34.6715"
                stroke="#C81D75"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="animated-path"
            />
            <style>{`
            .animated-path {
              stroke-dasharray: 140 142;
              stroke-dashoffset: 141;
              animation: animated-path-draw 800ms ease-in forwards;
            }
            @keyframes animated-path-draw {
              to {
                stroke-dashoffset: 0;
              }
            }
          `}</style>
        </svg>
    );

    const scribble2 = (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30.9251 6.08735C26.2675 6.22638 21.3656 7.28769 17.0474 8.98879C11.8438 11.0387 6.43122 14.0095 4.44717 19.5818C2.75117 24.345 3.97721 30.701 9.0183 32.9667C10.9978 33.8564 13.3803 33.7358 15.4781 33.4685C18.8656 33.037 22.0829 32.0061 25.1587 30.5397C29.5821 28.4309 34.0101 25.8092 34.6659 20.5398C35.0849 17.1734 34.9273 12.3953 32.7499 9.59097C30.8846 7.18866 27.8519 6.29237 24.958 5.86837C20.7117 5.24625 15.9734 5.26093 12.0201 7.12749C8.65648 8.71564 5.93986 11.6082 4.30119 14.9194C3.77664 15.9793 3.2401 17.2268 3.2063 18.4321C3.1749 19.5523 3.75396 20.0757 4.1552 21.0325"
                stroke="#C81D75"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="animated-path-2"
            />
            <style>{`
            .animated-path-2 {
              stroke-dasharray: 130 132;
              stroke-dashoffset: 131;
              animation: animated-path-2-draw 800ms ease-in forwards;
            }
            @keyframes animated-path-2-draw {
              to {
                stroke-dashoffset: 0;
              }
            }
          `}</style>
        </svg>
    );

    const scribble3 = (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.2018 26.2692C10.6393 25.7563 10.356 25.1904 10.056 24.4843C9.21976 22.5162 8.83373 20.396 8.83911 18.2579C8.84457 16.0939 9.27329 13.8184 10.7564 12.151C12.7087 9.95606 15.8033 9.05951 18.6192 8.73599C21.9367 8.35485 25.4118 8.62108 28.6479 9.4235C31.5001 10.1307 34.6741 11.3342 36.5914 13.6842C38.8603 16.465 37.8953 20.8747 36.3074 23.7516C35.4416 25.3201 34.1799 26.7143 32.6955 27.7185C30.263 29.364 27.3318 29.8864 24.4389 29.681C21.3704 29.463 18.4102 28.5014 15.6303 27.2182C13.38 26.1794 10.8315 24.8701 9.58796 22.6025C8.59481 20.7914 8.50789 18.5067 8.68418 16.4988C8.96821 13.2636 10.164 10.1376 12.9932 8.32283C15.9603 6.41967 19.6954 5.87645 23.1575 5.92783C26.1005 5.97151 28.8698 6.56549 31.5949 7.61918"
                stroke="#C81D75"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="animated-path-3"
            />
            <style>{`
            .animated-path-3 {
              stroke-dasharray: 120 122;
              stroke-dashoffset: 121;
              animation: animated-path-3-draw 800ms ease-in forwards;
            }
            @keyframes animated-path-3-draw {
              to {
                stroke-dashoffset: 0;
              }
            }
          `}</style>
        </svg>
    );

    return (
        <div className="custom-block map-block">
            <div className="full-width map">
                <Container >
                    <MapWithPopup data={props.data}/>
                </Container>
            </div>
            <>
                <div className="numbers">
                    {isEditMode ? (
                        <>
                            <TextLineEdit
                                {...filteredToolbarProps}
                                renderTag="h1"
                                renderClassName=""
                                fieldDataName="n1"
                                properties={{ n1: data?.n1 }}
                            />
                            <TextLineEdit
                                {...filteredToolbarProps}
                                renderTag="h1"
                                renderClassName=""
                                fieldDataName="n2"
                                properties={{ n2: data?.n2 }}
                            />
                            <TextLineEdit
                                {...filteredToolbarProps}
                                renderTag="h1"
                                renderClassName=""
                                fieldDataName="n3"
                                properties={{ n3: data?.n3 }}
                            />
                        </>
                    ) : (
                        <>
                            <div className='number-block'>
                                <p className='number'>{data?.n1}
                                    {scribble1}
                                </p>
                                <p>Hausärzte</p>
                            </div>
                            <div className='number-block'>
                                <p className='number'>{data?.n2}
                                    {scribble2}
                                </p>
                                <p>Neurologen</p>
                            </div>
                            <div className='number-block'>
                                <p className='number'>{data?.n3}
                                    {scribble3}
                                </p>
                                <p>Patienten</p>
                            </div>
                        </>
                    )}
                </div>
            </>
        </div>
    );
};

export default View;
